module.exports = __webpack_public_path__ + "img/tool4.82b8e712.png";